import { __decorate, __metadata } from "tslib";
import { lazyConsumer } from '@1inch-community/core/lazy';
import { observe, subscribe } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/icon';
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { when } from 'lit/directives/when.js';
import { defer, map, of, tap } from 'rxjs';
import { selectTokenContext } from '../../context';
import { searchTokenInputStyle } from './search-token-input.style';
let SearchTokenInputElement = class SearchTokenInputElement extends LitElement {
    constructor() {
        super(...arguments);
        this.isFocused = false;
        this.searchInProgress = false;
        this.context = lazyConsumer(this, { context: selectTokenContext });
        this.tokenListFlatView$ = defer(() => this.context.value.tokenListFlatView$);
        this.tokenListFlatViewToggleIcon$ = this.tokenListFlatView$.pipe(map((value) => (value ? 'alignJustify16' : 'alignRight16')));
    }
    static { this.tagName = 'inch-search-token-input'; }
    static { this.styles = searchTokenInputStyle; }
    render() {
        const classes = {
            'search-token-input-container': true,
            'search-token-input-container__focused': this.isFocused,
        };
        return html `
      <div class="${classMap(classes)}">
        <inch-icon icon="search24"></inch-icon>
        <input
          id="search"
          autofocus
          autocomplete="off"
          maxlength="40"
          @input="${(event) => this.onChange(event)}"
          @focus="${() => (this.isFocused = true)}"
          @blur="${() => (this.isFocused = false)}"
          placeholder="Search token by name or address"
          class="search-token-input"
        />
        ${when(this.searchInProgress, () => html `<span class="loader"></span>`, () => html ``)}
        <inch-button
          type="tertiary-gray"
          @click="${() => this.context.value.tokenListFlatViewToggle()}"
        >
          <inch-icon icon="${observe(this.tokenListFlatViewToggleIcon$)}"></inch-icon>
        </inch-button>
      </div>
    `;
    }
    async firstUpdated() {
        subscribe(this, [
            this.context.value.searchInProgress$.pipe(tap((state) => (this.searchInProgress = state))) ?? of(),
        ], { requestUpdate: false });
    }
    onChange(event) {
        const value = event.target.value;
        this.context.value.setSearchToken(value);
    }
};
__decorate([
    state(),
    __metadata("design:type", Object)
], SearchTokenInputElement.prototype, "isFocused", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], SearchTokenInputElement.prototype, "searchInProgress", void 0);
SearchTokenInputElement = __decorate([
    customElement(SearchTokenInputElement.tagName)
], SearchTokenInputElement);
export { SearchTokenInputElement };
//# sourceMappingURL=search-token-input.element.js.map